import Vue from 'vue';
import Dialog from '@/utils/Dialog';

Vue.prototype.$dialog = Dialog;
